import { Maximize2, RectangleHorizontal, Square } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useContentWidth, type ContentWidth } from './useContentWidth';

/** Mismos iconos (lucide) que el ajuste de competitions. */
const WIDTH_OPTIONS: Array<{ value: ContentWidth; icon: React.ReactElement }> =
    [
        { value: 'full', icon: <Maximize2 className="h-5 w-5" /> },
        { value: 'wide', icon: <RectangleHorizontal className="h-5 w-5" /> },
        { value: 'normal', icon: <Square className="h-5 w-5" /> },
    ];

/** Selector de ancho máximo del contenido. */
export function ContentWidthSetting(): React.ReactElement {
    const { t } = useTranslation();
    const { width, setWidth } = useContentWidth();

    return (
        <section className="flex flex-col gap-3">
            <div className="flex flex-col gap-1">
                <h3 className="m-0 text-sm font-medium">
                    {t('settings.contentWidth.label')}
                </h3>
                <p className="text-muted-foreground m-0 text-xs">
                    {t('settings.contentWidth.help')}
                </p>
            </div>
            <div className="grid grid-cols-3 gap-2">
                {WIDTH_OPTIONS.map((option) => {
                    const isActive = width === option.value;

                    return (
                        <button
                            key={option.value}
                            type="button"
                            aria-pressed={isActive}
                            onClick={() => setWidth(option.value)}
                            className={`flex cursor-pointer flex-col items-center gap-2 rounded-lg border p-4 transition-colors ${
                                isActive
                                    ? 'bg-primary text-primary-foreground border-primary-foreground'
                                    : 'border-border text-foreground hover:bg-accent'
                            }`}
                        >
                            {option.icon}
                            <span className="text-xs font-medium">
                                {t(`settings.contentWidth.${option.value}`)}
                            </span>
                        </button>
                    );
                })}
            </div>
        </section>
    );
}
